module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#tick",
      toString: function () {
        return this.url;
      }
    }